import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, Navigate, useParams } from "react-router-dom";

import "../../styles/authstyles.scss";
import { reset_password_confirm } from "../../actions/auth";
import { useDispatch } from "react-redux";

const PasswordResetConfirm = () => {
  const dispatch = useDispatch();
  const { uid, token } = useParams();
  const [isReseted, setIsReseted] = useState(false);
  const [passwords, setPasswords] = useState({
    new_password1: "",
    new_password2: "",
  });
  const [formAlerts, setFormAlerts] = useState({
    new_password1: false,
    new_password2: false,
    passwords_equal: true,
    token_not_valid: false,
  });
  const onChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };
  const dataIsValid = () => {
    let isNotValid = false;
    const passwordsData = { ...passwords };
    Object.keys(passwords).forEach((key) => {
      if (passwords[key] === "" || passwords[key].length < 8) {
        formAlerts[key] = true;
        isNotValid = true;
      } else {
        formAlerts[key] = false;
      }
      if (passwords.new_password1 != passwords.new_password2) {
        setFormAlerts({ ...formAlerts, passwords_equal: false });
        isNotValid = true;
      }
      setTimeout(() => {
        setFormAlerts({
          new_password1: false,
          new_password2: false,
          passwords_equal: true,
          token_not_valid: true,
        });
      }, 3500);
    });
    setPasswords(passwordsData);
    return isNotValid;
  };
  const onsubmit = (e) => {
    e.preventDefault();

    const { new_password1, new_password2 } = passwords;
    const isNotValid = dataIsValid();
    if (!isNotValid) {
      const response = dispatch(
        reset_password_confirm(uid, token, new_password1, new_password2),
      )
        .then(() => {
          console.log("not catched");
          setPasswords({ new_password1: "", new_password2: "" });
          setIsReseted(true);
        })
        .catch(() => {
          console.log("catched");
          setFormAlerts({ ...formAlerts, token_not_valid: true });
        });
    }
  };
  if (isReseted) {
    return (
      <div className="reset-password-page">
        <div className="reset-password-body d-flex flex-column justify-content-center">
          <div className="text-center py-8">
            <h3 className="text-xl font-semibold mb-2">
              Contraseña Actualizada!
            </h3>
            <p className="text-muted-foreground text-sm mb-6">
              La contraseña se actualizo correctamente. Puedes iniciar sesión
              con tu nueva contraseña.
            </p>
            <Link to="/login">
              <Button className="w-100">
                Inicio de Sesion
                <i class="mx-2 bi bi-arrow-right-square"></i>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Form className="reset-password-page" href="#">
      <div className="reset-password-body d-flex flex-column justify-content-center">
        <div className="reset-password-title">
          <h2>Actualizar Contraseña</h2>
        </div>
        <Form.Group
          className="password-input-group mb-3"
          controlId="formBasicPassword1"
        >
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            className={formAlerts.new_password1 ? "border border-danger" : ""}
            name="new_password1"
            type="password"
            value={passwords.new_password1}
            onChange={(e) => onChange(e)}
          />
          <span
            className={
              formAlerts.new_password1 ? "fst-italic m-2 text-danger" : "d-none"
            }
          >
            Campo no valido o vacio.
          </span>
        </Form.Group>
        <Form.Group
          className="password-input-group mb-3"
          controlId="formBasicPassword2"
        >
          <Form.Label>Confirmar Contraseña</Form.Label>
          <Form.Control
            className={formAlerts.new_password2 ? "border border-danger" : ""}
            name="new_password2"
            type="password"
            value={passwords.new_password2}
            onChange={(e) => onChange(e)}
          />
          <span
            className={
              formAlerts.new_password2 ? "fst-italic m-2 text-danger" : "d-none"
            }
          >
            Campo no valido o vacio.
          </span>
        </Form.Group>

        <span
          className={
            formAlerts.passwords_equal ? "d-none" : "fst-italic m-2 text-danger"
          }
        >
          Las contraseñas no coinciden.
        </span>
        <Button variant="primary" type="submit" onClick={(e) => onsubmit(e)}>
          Cambiar contraseñas
        </Button>
        <span
          className={
            formAlerts.token_not_valid
              ? "fw-bold fst-italic m-2 text-danger"
              : "d-none"
          }
        >
          Ha habido un error con el Token, solicite otro enlace de reseteo de
          contraseña.
        </span>
        <span className="fw-bold m-2">
          Ir al login <Link to="/login">aquí</Link>
        </span>
      </div>
    </Form>
  );
};

export default PasswordResetConfirm;
